<template>
    <div class="popView" v-if="comsShow">
      <div class="popView1">
        <div class="titleDiv">
          <img :src="icon" class="statusImg" />
          <div class="title">{{ labMsg }}</div>
          
        </div>
        <div class="content" v-if="content">{{ content }}</div>
        <a-button
        :size="'small'"
          class="chooseDependComs"
          v-for="(item, index) in btnList"
          :key="index"
          :type="item.type"
          @click="emitFn(item)"
          >{{ item.name }}</a-button
        >
      </div>
    </div>
  </template>
  
  <script>
  const closeCircle = require('./assets/CloseCircle.png')
  const infoIcon = require("./assets/info-outline.png");
  const successIcon = require("./assets/success.png");
  const warningIcon = require("./assets/warning.png");
  export default {
    name: 'msgPop',
    components: {
    },
    data() {
      return {
        iconType:2,
        icon: warningIcon,
        labMsg: '密码已过期',
        content: '为了保障您的账户安全，请立即修改您的密码',
        btnList:[
          {
            name: "确定", //按钮名称
            type: "primary", //按钮类型
            fn:null, //按钮方法
          },
          {
            name: "取消",
            type: "default",
            fn: null,
          },
        ],
        comsShow:false
      }
    },
    computed: {
  
    },
    created () {
    },
    mounted () {
  
    },
    methods: {
      open(){
  
      },
      cancel(){
        this.comsShow = false;
      },
      emitFn(item){
        if (item.name === "取消") {
  
          this.comsShow = false;
          return;
        }
        item.fn()
      }   
    },
    watch:{
       //图标：0信息，1成功，2警告
      iconType(nv){
        const status = nv;
        if (status === 0) {
          this.icon = infoIcon;
        }
        if (status === 1) {
          this.icon = successIcon;
        }
        if (status === 2) {
          this.icon = warningIcon;
        }
        if (status === 3) {
          this.icon = closeCircle;
        }
      }
    }
    
  }
  
  
  
  
  // defineExpose({
  //   comsShow,
  //   content,
  //   btnList,
  //   labMsg,
  //   iconType
  // });
  </script>
  <style scoped>
  .popView {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100000000;
    display: flex;
    justify-content: center;
    align-items: center;
    .popView1 {
      width: 400px;
      padding: 25px;
      z-index: 100000000;
      background: #ffffff;
      box-shadow: 0px 4px 16px -2px rgba(0, 0, 0, 0.08),
        0px 4px 16px rgba(0, 0, 0, 0.06), 0px 4px 16px 4px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      .titleDiv {
        display: flex;
        align-items: top;
        .statusImg {
          margin-top: 3.5px;
          height: 17px;
          width: 17px;
        }
        .title {
          margin-left: 10px;
          font-family: "Source Han Sans CN";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          color: #000000;
        }
      }
      .content{
        margin-top: 14px;
        margin-left: 27px;
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        color: rgba(0, 0, 0, 0.85);
      }
  
      .chooseDependComs {
        margin-top: 33px;
        float: right;
        margin-left: 16px;
      }
    }
  }

  ::v-deep .ant-btn{
    height:32px;
    line-height:32px;
    font-size:14px;
  }
  </style>
  